import React from 'react'
import img1 from '../../assets/images/Banner1.png'
import img2 from '../../assets/images/Banner2.png'
import img3 from '../../assets/images/Banner3.png'

import BannerItem from './BannerItem'

const bannerData = [
    {
        image: img1,
        prev: 3,
        id: 1,
        next: 2
    },
    {
        image: img2,
        prev: 1,
        id: 2,
        next: 3
    },
    {
        image: img3,
        prev: 2,
        id: 3,
        next: 1
    },
]



const Banner = () => {


    return (
        <div className="carousel w-full py-10">
            {
                bannerData.map(banner =>
                    <BannerItem
                        key={banner.id}
                        banner={banner}
                    ></BannerItem>)
            }
        </div>
    )
}

export default Banner
